import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#0a0a0a]/70 border-b border-white/5"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <span className="font-display text-xl font-medium tracking-tight">
            14<span className="text-zinc-500">/</span>ScaleGrid
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm text-zinc-300">
          <a href="/#curriculum" className="hover:text-white transition" data-testid="nav-curriculum">
            Curriculum
          </a>
          <a href="/#pricing" className="hover:text-white transition" data-testid="nav-pricing">
            Pricing
          </a>
          <a href="/#faq" className="hover:text-white transition" data-testid="nav-faq">
            FAQ
          </a>
        </div>

        <div className="flex items-center gap-3">
          {user && user !== false ? (
            <>
              <Link
                to="/dashboard"
                className="text-sm text-zinc-300 hover:text-white transition hidden sm:inline"
                data-testid="nav-dashboard"
              >
                Dashboard
              </Link>
              <button
                onClick={handleLogout}
                className="btn-secondary !py-2 !px-4 text-sm"
                data-testid="nav-logout"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="text-sm text-zinc-300 hover:text-white transition"
                data-testid="nav-login"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="btn-primary !py-2 !px-4 text-sm"
                data-testid="nav-register"
              >
                Get Started
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
